import Body       from './Body';
import Filter     from './Filter';
import Search     from './Search';
import ShowInfo   from './ShowInfo';
import TimeFilter from './TimeFilter';

export const Components = {
  Body,
  Filter,
  TimeFilter,
  ShowInfo,
  Search,
};
